<template>
    <div>
        <modal :show.sync="show_modal" :hide-footer="true">
            <div v-if="approval" style="min-width: 500px !important;">
                <div>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th class="bg-dark text-white py-2" width="150px">Approval ID</th>
                                <td class="py-2">#{{ approval.approval_id}}</td>
                            </tr>
                            <tr>
                                <th class="bg-dark text-white py-2 text-break" width="150px">Title</th>
                                <td class="py-2">{{ approval.appr_content}}</td>
                            </tr>
                            <tr>
                                <th class="bg-dark text-white py-2">Requester</th>
                                <td class="py-2">{{ approval.created_by_detail.name }}</td>
                            </tr>
                            <tr>
                                <th class="bg-dark text-white py-2 text-break">Requester Remark</th>
                                <td class="py-2">{{ approval.appr_remark || '-' }}</td>
                            </tr>
                            <tr>
                                <th class="bg-dark text-white py-2">Requested Value</th>
                                <td class="py-2">
                                    <a href="javascript:void(0)" @click="$emit('preview-value', approval.approval_type)" class="text-primary"><i class="fa fa-eye"></i></a>
                                </td>
                            </tr>
                            <tr>
                                <th class="bg-dark text-white py-2">Requested At</th>
                                <td class="py-2">{{ approval.created_at | dateTimeFormatString }}</td>
                            </tr>
                        </thead>
                    </table>
                    <table class="table table-bordered" v-for="(reviewers, index) in approvalReviewerGroupByOrders" :key="index">
                        <thead>
                            <tr>
                                <th class="bg-dark text-white py-2" width="150px">
                                    <span v-if="index !== reviewers.length - 1">Reviewer {{ index+1 }}</span>
                                    <span v-else>Approver</span>
                                </th>
                                <td class="py-2">
                                    <span v-for="(reviewer,index) in reviewers" :key="index">
                                        <span :class="[reviewer.appr_rev_status !== null ? 'font-weight-bold': '']">{{ reviewer.appr_rev_user_detail.name }}</span> 
                                        <span v-if="index !== reviewers.length - 1">, </span>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th class="bg-dark text-white py-2 text-break" width="150px">Remark</th>
                                <td class="py-2">
                                    <span v-for="(reviewer,index) in reviewers" :key="index">
                                        <span v-if="reviewer.appr_rev_remark" class="mb-2"> {{ reviewer.appr_rev_remark || '-' }}</span>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th class="bg-dark text-white py-2" width="150px">Reviewed At</th>
                                <td class="py-2">
                                    <span v-for="(reviewer,index) in reviewers" :key="index">
                                        <span v-if="reviewer.appr_rev_reviewed_date">{{ reviewer.appr_rev_reviewed_date |  dateTimeFormatString}}</span>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th class="bg-dark text-white py-2" width="150px">Status</th>
                                <td class="py-2">
                                    <span v-for="(reviewer,index) in reviewers" :key="index">
                                        <span class="text-success font-weight-bold mr-2" v-if="reviewer.appr_rev_status === 1">Approved</span>
                                        <span class="text-danger font-weight-bold mr-2" v-if="reviewer.appr_rev_status === 0">Rejected</span>
                                    </span>
                                </td>
                            </tr>
                        </thead>
                    </table>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th class="bg-dark text-white py-2" width="150px">Final Status</th>
                                <td class="py-2">
                                    <span class="text-success font-weight-bold mr-2" v-if="approval.appr_final_status === 1">Approved</span>
                                    <span class="text-danger font-weight-bold mr-2" v-if="approval.appr_final_status === 0">Rejected</span>
                                </td>
                            </tr>
                            <tr v-if="approval.appr_final_status === 1">
                                <th class="bg-dark text-white py-2" width="150px">Final Value</th>
                                <td class="py-2">
                                    <a href="javascript:void(0)" @click="$emit('preview-value', approval.approval_type)" class="text-primary"><i class="fa fa-eye"></i></a>
                                </td>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </modal>  
    </div>
</template>
<script>
    import { Button } from 'element-ui'

    export default {
        props: ['approval'],
        components: {
            [Button.name]: Button,
        },
        computed:{
            approvalReviewerGroupByOrders(){
                const groupedArray = this.approval.approval_reviewers.reduce((result, item) => {
                const order = item.app_rev_order;
                if (!result[order]) {
                    result[order] = [];
                }
                result[order].push(item);
                return result;
                }, {});
                
                return Object.values(groupedArray);
            }
        },
        data() {
            return {
                show_modal: false,
                remark: '',
            }
        },
        methods: {
            toggleView() {
                this.show_modal = !this.show_modal;
            }
        },
    }
</script>